
import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { PanelComponent } from '@components/core/panel/panel.component';
import { EntityService } from '@services/core/entity.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'app-edit-office',
  templateUrl: './editOffice.component.html',
  styleUrls: ["./editOffice.component.css"],
    imports: [PanelComponent, ReactiveFormsModule],
	changeDetection: ChangeDetectionStrategy.Default,
	standalone: true,
})
export class EditOfficeComponent implements OnInit{
    @Input() office: any
    @Output() close = new EventEmitter()
    @Output() update = new EventEmitter()
    private entityService = inject(EntityService)
	private _fb = inject(FormBuilder)
    private destroyRef = inject(DestroyRef)
    public officeForm: FormGroup 
    protected groups
    protected offices

	ngOnInit(): void {
        this.officeForm = this._fb.group({
            id: [null],
            name: [null, [Validators.required]],
            acronym: [null, [Validators.required]],
            enabled: [true]
        })
        if(this.office) this.setForm()
	}

    setForm(){
        this.officeForm.patchValue({
            id: this.office.id,
            name: this.office.name,
            acronym: this.office.acronym,
            enabled: this.office.enabled
        })
    }

    save(){
        this.entityService.updateOffice(this.officeForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
            this.update.emit()
        })
    }

    cancel(){
        this.close.emit()
    }
  
}
